export default function PoolSharkIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="4" y="10" width="56" height="44" rx="8" fill="#6b3415" />
      <rect x="10" y="16" width="44" height="32" rx="3" fill="#1f9c5a" />
      <circle cx="11" cy="17" r="3.5" fill="#0a0a0a" />
      <circle cx="53" cy="17" r="3.5" fill="#0a0a0a" />
      <circle cx="11" cy="47" r="3.5" fill="#0a0a0a" />
      <circle cx="53" cy="47" r="3.5" fill="#0a0a0a" />
      <circle cx="40" cy="30" r="6" fill="#151515" />
      <circle cx="40" cy="30" r="2.6" fill="#fff" />
      <circle cx="47" cy="38" r="5" fill="#f5c518" />
      <circle cx="22" cy="36" r="5" fill="#f8f4e8" />
      <path d="M17 41L2 56" stroke="#f2d7a0" strokeWidth="4" strokeLinecap="round" />
      <path d="M8 50L2 56" stroke="#2a160a" strokeWidth="4" strokeLinecap="round" />
    </svg>
  );
}
